import SectionHeading from "@/pages/home/components/SectionHeading";
import { safetyTips } from "@/mocks/doumanData";

export default function SafetySection() {
  return (
    <section id="safety" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="安全提示"
          title="用得顺手，也要用得安心"
          desc="在寻找入口和长期阅读的过程中，保护好账号与个人信息同样重要。以下四点建议可以帮你避开大多数风险。"
        />

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {safetyTips.map((tip) => (
            <article key={tip.title} className="p-6 rounded-lg bg-background-100 border border-background-200">
              <span className="w-12 h-12 rounded-lg bg-secondary-100 text-secondary-900 flex items-center justify-center">
                <i className={`${tip.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading font-bold text-base text-foreground-950">{tip.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{tip.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-10 p-6 md:p-8 rounded-lg bg-primary-50 border border-primary-100 flex flex-col md:flex-row md:items-center gap-5 md:gap-8">
          <span className="shrink-0 w-14 h-14 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-compass-discover-line text-2xl" aria-hidden="true"></i>
          </span>
          <div className="flex-1">
            <h3 className="font-heading font-bold text-lg text-foreground-950">还没找到合适的入口？</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              回到页面顶部的「访问入口」与「最新地址」分区，按顺序对照排查，多数情况都能顺利进入。
            </p>
          </div>
          <a
            href="#top"
            className="shrink-0 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-bold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap text-center"
          >
            返回顶部重新查看
          </a>
        </div>
      </div>
    </section>
  );
}